var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSubscription = function SvgSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#subscription_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
    fill: "#309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 17.379V26h-5.66c-.67-.298-1.393-.461-2.01-.6-.524-.119-.971-.22-1.243-.37-.657-.366-.908-1.09-.394-1.766.487-.642 1.638-.42 2.154-.322l.078.015 1.59.54-3.455-5.247c-.717-1.048-1.156-2.376-.367-2.916.788-.54 1.663-.044 2.232.788l2.568 3.45c-.696-1.016 1.182-2.436 2.218-1.517.608-1.096 1.553-1.287 2.29-.676ZM8.454 3.43c-2.309.371-4.128 4.503-4.128 9.545s1.82 9.173 4.128 9.545a2.134 2.134 0 0 1-.34.027c-2.466 0-4.466-4.286-4.466-9.572 0-5.287 2-9.573 4.466-9.573.115 0 .228.01.34.028Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.263 3.43c-2.308.371-4.127 4.503-4.127 9.545s1.819 9.173 4.127 9.545a2.135 2.135 0 0 1-.34.027c-2.466 0-4.466-4.286-4.466-9.572 0-5.287 2-9.573 4.467-9.573.114 0 .227.01.339.028Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.524 3.43c-2.308.371-4.127 4.503-4.127 9.545s1.819 9.173 4.127 9.545a2.135 2.135 0 0 1-.339.027c-2.467 0-4.466-4.286-4.466-9.572 0-5.287 2-9.573 4.466-9.573.114 0 .227.01.34.028Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.57 18.558c1.015 0 1.838-2.5 1.838-5.583 0-3.084-.823-5.584-1.838-5.584-.492 0-.939.588-1.269 1.545.543.61.93 2.188.93 4.039 0 1.85-.387 3.428-.93 4.038.33.957.777 1.545 1.27 1.545Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "subscription_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
    fill: "#fff"
  })))));
};
export default SvgSubscription;